import { assetsApi } from '../api/client';

/**
 * Fetch all gallery images from the backend API.
 * Signature kept for backward compatibility; supabase/supabaseUrl params are ignored.
 */
export async function fetchAllImages(_supabase, _supabaseUrl, options = {}) {
  const { includeSystemFolders = true } = options;
  return assetsApi.listPhotos(includeSystemFolders);
}

/**
 * Fetch all folder paths from the backend API.
 * Signature kept for backward compatibility; supabase param is ignored.
 */
export async function fetchAllFolders(_supabase) {
  return assetsApi.listFolders();
}

/**
 * Fetch certificate images from the backend API.
 * Signature kept for backward compatibility; supabase/supabaseUrl params are ignored.
 */
export async function fetchCertificateImages(_supabase, _supabaseUrl) {
  return assetsApi.listCertificates();
}
